"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OffersLettersSearch;
const react_1 = __importStar(require("react"));
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const LettersController_1 = require("./LettersController");
const LetterFilterBody_1 = require("./LetterFilterBody");
const LetterModalButtons_1 = require("./Modals/LetterModalButtons");
const SigningRowActions_1 = require("../../Letters/Signing/SigningRowActions");
const LetterRowContent_1 = require("../../Letters/LettersList/LetterRowContent");
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
function OffersLettersSearch({ title }) {
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    function buildLabelFromEntities(entities) {
        if (!entities || entities.length === 0)
            return "";
        let label = "";
        for (let i = 0; i < entities.length - 1; i++) {
            label += entities[i].name + "\n ";
        }
        label += entities[entities.length - 1].name;
        return label;
    }
    function makeEntitiesLabel(letter) {
        const mainEntitiesLabel = buildLabelFromEntities(letter._entitiesMain || []);
        const ccEntitiesLabel = buildLabelFromEntities(letter._entitiesCc || []);
        if (!mainEntitiesLabel)
            return react_1.default.createElement(react_1.default.Fragment, null);
        let label = mainEntitiesLabel;
        if (ccEntitiesLabel?.length > 0) {
            label += "\n\nDW: " + ccEntitiesLabel;
        }
        return react_1.default.createElement("div", { style: { whiteSpace: "pre-line" } }, label);
    }
    function renderIconTdBody(letter) {
        return react_1.default.createElement(LetterRowContent_1.LetterRowMarkers, { letter: letter });
    }
    function renderRowContent(letter) {
        return (react_1.default.createElement(LetterRowContent_1.LetterRowContent, { letter: letter, context: "offer", 
            // Status tylko do odczytu — edycja statusu pisma ofertowego nie istniała
            // w tym rejestrze i nie jest przedmiotem tej zmiany.
            renderStatus: (rowLetter) => (rowLetter.status ? react_1.default.createElement(CommonComponents_1.LetterStatusBadge, { status: rowLetter.status }) : null) }));
    }
    return (react_1.default.createElement(FilterableTable_1.default, { id: "offersLetters", title: title, FilterBodyComponent: LetterFilterBody_1.LettersFilterBody, tableStructure: [
            // Ta sama siatka co w rejestrze pism kontraktowych — daty zeszły do paska meta.
            // Suma colLg maks. 11: dwunasta kolumna jest zarezerwowana na RowActionMenu.
            { renderThBody: () => react_1.default.createElement("i", { className: "fa fa-inbox fa-lg" }), renderTdBody: renderIconTdBody, colLg: 1 },
            { header: "Pismo", renderTdBody: renderRowContent, colLg: 7 },
            { header: "Odbiorcy", renderTdBody: makeEntitiesLabel, colLg: 3 },
        ], AddNewButtonComponents: [LetterModalButtons_1.OurLetterAddNewModalButton, LetterModalButtons_1.IncomingLetterAddNewModalButton], EditButtonComponent: LetterModalButtons_1.LetterEditModalButton, RowActionMenuComponents: [LetterModalButtons_1.ExportOurLetterOfferToPDFButton, SigningRowActions_1.SignOurLetterPdfButton, SigningRowActions_1.UploadSignedLetterButton], isDeletable: true, repository: LettersController_1.lettersRepository, selectedObjectRoute: "/letter/" }));
}
